import ShowMoreTabs from './show-more-tabs/index.js';
import moreButtonPlugin_buttonComponent from './button/index.js';
import moreButtonPlugin_iconComponent from './icon.js';
import setComponents from './setComponents.js';
export default setComponents.bind(undefined, {
  moreButtonPlugin_buttonComponent: moreButtonPlugin_buttonComponent,
  ShowMoreTabs: ShowMoreTabs,
  moreButtonPlugin_iconComponent: moreButtonPlugin_iconComponent
});